<div class="container-fluid text-center pt-3">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 section">
            <div class="row px-4">
                <div class="col-4 col-xl-3">
                    <div class="email-icon-section mx-3">
                        <div class="email-icon-bg mx-auto mt-5 mt-lg-3 mb-5 mb-lg-3">
                            <img src="../../../../../assets/Images/email.svg" alt="Email">
                        </div>
                    </div>
                </div>
                <div class="col-3 col-xl-4">
                    <div class="d-flex flex-column text-left">
                        <span class="mt-3 mt-xl-5 section-title">Subscribe to our newsletter</span>
                        <span class="section-sub-title mt-3 mb-2">Signup to get pregnancy related advice emailed based on your due date</span>
                    </div>
                </div>
                <div class="col-3">
                    <input class="form-control form-control-lg email-input" placeholder="Your email address">
                </div>
                <div class="col-2">
                    <button class="btn btn-theme">Subscribe</button>
                </div>
            </div>
        </div>
    </div>
</div>